<template>
  <label class="switch">
    <input type="checkbox"
           :checked="checked"
           :disabled="disabled"
           @click="clicked">
    <span class="slider"></span>
  </label>
</template>

<script>
export default {
  name: 'TSwitch',
  props: ['checked', 'disabled', 'anotherFunction'],
  methods: {
    clicked() {
      this.anotherFunction();
    },
  },
};
</script>

<style scoped lang="scss">

  @import '../../assets/scss/theme';
  /* The switch - the box around the slider */
  .switch {
    position: relative;
    display: inline-block;
    width: 3.25rem;
    height: 1.2rem;
  }

  /* Hide default HTML checkbox */
  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  /* The slider */
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: $dark25;
    transition: .4s;
    border-radius: 0.625rem;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: .8rem;
    width: .8rem;
    left: 0.225rem;
    bottom: 0.225rem;
    background-color: $white;
    transition: .4s;
    border-radius: 50%;
  }

  input:checked + .slider {
    background-color: $dark100;
  }

  input:focus + .slider {
    box-shadow: 0 0 1px $dark75;
  }

  input:checked + .slider:before {
    transform: translateX(1.9rem);
  }

  input:disabled + .slider {
    background: $dark10;
    cursor: default;
  }

</style>
